// @flow
export const LOGIN = 'login';
export const REGISTER = 'register';
export const FORGOT = 'forgot';
export const AVALIABLE_MENU_STATE = {
    signin: LOGIN,
    signup: REGISTER,
    forgot: FORGOT,
};
